export type AuthTracking = {
  signInAttemptId?: string;
  source?: string;
  variant?: string;
};

export const authTrackingPayload = (authTracking?: AuthTracking | null) => ({
  sign_in_attempt_id: authTracking?.signInAttemptId,
  source: authTracking?.source,
  variant: authTracking?.variant,
});
